import React from 'react';
import { Calendar, Clock, CheckCircle2, XCircle, AlertCircle } from 'lucide-react';
import TeamCalendar from './TeamCalendar';

export default function LeaveDashboard({ 
  holidays, 
  activeTab, 
  setShowModal, 
  handleApprove, 
  handleReject,
  handleCancel,
  currentUserRole,
  currentUserId,
  currentUser
}) {
  const filteredHolidays = holidays.filter(h => {
    if (activeTab === 'all') return true;
    return h.status === activeTab;
  });

  const nextUpcoming = holidays
    .filter(h => h.employeeId === currentUserId && h.status === 'approved' && new Date(h.startDate) >= new Date())
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))[0];

  return (
    <div className="stats-grid" style={{ display: 'block' }}>
      
      {/* Metrics Row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '24px' }}>
        <div className="stat-card">
          <div className="stat-header">
            <span>My Available Balance</span>
            <Calendar size={18} color="var(--primary-500)" />
          </div>
          <div className="stat-value">{currentUser?.currentBalance !== undefined ? currentUser.currentBalance : 0} <span style={{ fontSize: '1rem', color: 'var(--text-dim)' }}>Days</span></div>
        </div>

        <div className="stat-card">
          <div className="stat-header">
            <span>My Next Upcoming Leave</span>
            <AlertCircle size={18} color="var(--accent-emerald)" />
          </div>
          <div className="stat-value" style={{ fontSize: '1.2rem' }}>
            {nextUpcoming ? `${nextUpcoming.startDate} (${nextUpcoming.durationDays}d)` : 'None scheduled'}
          </div>
        </div>

        {(currentUserRole === 'manager' || currentUserRole === 'hr_admin' || currentUserRole === 'owner') && (
          <div className="stat-card">
            <div className="stat-header">
              <span>Pending Approvals</span>
              <Clock size={18} color="var(--accent-amber)" />
            </div>
            <div className="stat-value">
              {holidays.filter(h => h.status?.startsWith('pending') && h.employeeId !== currentUserId).length}
            </div>
          </div>
        )}
      </div>

      <TeamCalendar holidays={holidays} />

      {/* Leave Requests List */}
      <div className="card">
        <h3 style={{ marginBottom: '16px', fontSize: '1.1rem', fontWeight: 600 }}>Recent Leave Requests</h3>
        
        {filteredHolidays.length === 0 ? (
          <div style={{ padding: '32px', textAlign: 'center', color: 'var(--text-muted)' }}>
            <p>No holiday records found.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border-color)', textAlign: 'left', color: 'var(--text-muted)' }}>
                  <th style={{ padding: '12px' }}>Employee</th>
                  <th style={{ padding: '12px' }}>Type</th>
                  <th style={{ padding: '12px' }}>Dates</th>
                  <th style={{ padding: '12px' }}>Duration</th>
                  <th style={{ padding: '12px' }}>Status</th>
                  <th style={{ padding: '12px' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredHolidays.map(h => (
                  <tr key={h.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                    <td style={{ padding: '12px' }}>
                      <div style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{h.employeeName || 'Staff Member'}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>ID: {h.employeeId || 'N/A'}</div>
                    </td>
                    <td style={{ padding: '12px', textTransform: 'capitalize' }}>
                      {h.type.replace('_', ' ')}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {h.startDate} <span style={{ color: 'var(--text-muted)' }}>to</span> {h.endDate}
                    </td>
                    <td style={{ padding: '12px' }}>
                      <span style={{ fontWeight: 500 }}>{h.durationDays}</span> days
                    </td>
                    <td style={{ padding: '12px' }}>
                      <span className={`status-badge status-${h.status || 'unknown'}`}>
                        {h.status === 'approved' && <CheckCircle2 size={12} />}
                        {h.status === 'rejected' && <XCircle size={12} />}
                        {h.status?.startsWith('pending') && <Clock size={12} />}
                        {(h.status || 'unknown').replace('_', ' ')}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        {((h.status === 'pending_manager' && currentUserRole === 'manager') || (h.status === 'pending_hr' && (currentUserRole === 'hr_admin' || currentUserRole === 'owner'))) && (
                          <>
                            <button 
                              className="btn btn-outline" 
                              style={{ padding: '4px 8px', fontSize: '0.8rem', borderColor: 'var(--accent-emerald)', color: 'var(--accent-emerald)' }}
                              onClick={() => handleApprove(h.id)}
                            >
                              Approve
                            </button>
                            <button 
                              className="btn btn-outline" 
                              style={{ padding: '4px 8px', fontSize: '0.8rem', borderColor: 'var(--accent-rose)', color: 'var(--accent-rose)' }}
                              onClick={() => handleReject(h.id)}
                            >
                              Reject
                            </button>
                          </>
                        )}
                        {h.status !== 'cancelled' && h.status !== 'rejected' && (h.employeeId === currentUserId || currentUserRole === 'hr_admin' || currentUserRole === 'owner') && (
                          <button 
                            className="btn btn-outline" 
                            style={{ padding: '4px 8px', fontSize: '0.8rem', borderColor: 'var(--text-muted)', color: 'var(--text-muted)' }}
                            onClick={() => handleCancel(h.id)}
                          >
                            Cancel
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
